export default __webpack_public_path__ + "static/media/FilteringTokens.ef3c2a7f.mp4";